export { censorWords }
const censorWords = function(text, wordList) {
    const rgx = new RegExp(wordList.join("|"), "gi")
    return text.replace(rgx, "****")
}
